import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Modal, Form, Button, Space, Typography } from 'antd'
import { Formik, Field } from 'formik'

import { userNoteSchema } from '../../../../schema/userNotes'
import TextareaField from '../../../shared/TextareaField'

const UserNotesModal = ({ visible, onCancel, onSubmit, isSaving, editingNote }) => {
  const noteFormRef = useRef(null)

  const formInitialValues = {
    note: editingNote ? editingNote.note : '',
  }

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      closable={false}
      centered
      maskStyle={{
        background: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(10px)',
      }}
    >
      <Typography.Title level={3} style={{ margin: '8px 0 24px 0' }}>
        {editingNote ? 'Edit Note' : 'Add New Note'}
      </Typography.Title>
      <Formik
        innerRef={noteFormRef}
        initialValues={formInitialValues}
        validationSchema={userNoteSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ handleSubmit, dirty, isValid, values }) => (
          <Form onFinish={handleSubmit} layout="vertical">
            <Field
              component={TextareaField}
              name="note"
              placeholder="Enter your note..."
              autoSize={{ minRows: 3, maxRows: 6 }}
            />
            <Form.Item style={{ margin: '16px 0 0' }}>
              <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button onClick={onCancel} disabled={isSaving}>
                  Cancel
                </Button>
                <Button
                  className={editingNote ? 'ant-btn-background-ghost' : ''}
                  type="primary"
                  htmlType="submit"
                  disabled={!dirty || !isValid || isSaving || !values.note.trim()}
                  loading={isSaving}
                >
                  {editingNote ? 'Edit' : 'Save'}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

UserNotesModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  editingNote: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    note: PropTypes.string,
  }),
}

UserNotesModal.defaultProps = {
  editingNote: null,
}

export default UserNotesModal
